import React from 'react'
import { Button } from '@mc/design-system'
import { StyledFeatureVariable } from '@mc/feature-variables'
import { withI18nContext, useTranslation } from '@mc/i18n'
import { pathsWithQueryParams } from '@mc/paths'
import { i18nInstance } from '../../../i18n'
import {
  PROMO_FEATURE_FLAG,
  PROMO_I18N_NAMESPACE,
} from '../../../lib/constants'
import { getIsGift } from '../utils'
import { useDiscountModal } from './DiscountModalContext'

const PromotionAppliedOnErrorCtaComp = () => {
  const { t } = useTranslation(PROMO_I18N_NAMESPACE)

  const { discount, onClose, query, pathname } = useDiscountModal()
  const isGift = getIsGift({ discount, pathname })

  return (
    <Button
      render={
        <a
          href={pathsWithQueryParams.checkout({
            isGift,
            query,
          })}
        />
      }
      accessibleWhenDisabled
      fullWidth
      className='mc-mb-3'
      onClick={(e: React.MouseEvent<HTMLElement, MouseEvent>) =>
        onClose(e.currentTarget?.innerText)
      }
    >
      <StyledFeatureVariable
        flagName={PROMO_FEATURE_FLAG}
        variableName='discount_copy'
        defaultCopy={t(
          'common.home.modals.discount.promotionAppliedOnError.cta',
        )}
      />
    </Button>
  )
}

export const PromotionAppliedOnErrorCta = withI18nContext(i18nInstance)(
  PromotionAppliedOnErrorCtaComp,
)
